// The public tutorial page (the QR target, /tutorials/:slug) is a different surface from
// the authoring app: its own brand tokens (notice-blue / ink / cream, see
// index.css) and its own language rule. Detected from the URL, evaluated at load
// — which is how the page is always reached, a fresh QR scan — so it needn't
// react to in-app SPA navigation.
//
// This used to live in ThemeContext, back when its job was to keep the light/dark
// toggle off this page. The app has one look now and no toggle, so the theme
// context is gone and the route test outlived it.
// Its one address, /tutorials/<slug>.
export function isPublicTutorialRoute(pathname: string = window.location.pathname): boolean {
  return /\/tutorials\/[^/]+\/?$/.test(pathname);
}

// A TOOLTIP, except on the published tutorial, which shows none (Louis 2026-10-23): it is read on
// a phone, where a tooltip never appears, and on a computer the label floating over the product
// was noise. Every control keeps its aria-label.
export const tip = (text: string | null | undefined): string | undefined =>
  isPublicTutorialRoute() ? undefined : text ?? undefined;
